<template>
  <div>
    <ts-dialog title="Share this page by link" :visible.sync="visible" width="500px" center>
      <div class="flex items-center justify-center mb-2">
        <div class="row">
          <p class="font-semibold" v-text="url"></p>
        </div>
        <div class="actions">
          <ts-button size="small" circle @click="copy">
            <ts-icon icon="link" size="x-small" title="Copy" color="#6d7587" />
          </ts-button>
        </div>
      </div>
      <div slot="footer" class="flex items-center justify-center">
        <div class="font-semibold">
          <ts-button class="font-semibold" title="Close" @click="handleCloseButton">Close</ts-button>
        </div>
      </div>
    </ts-dialog>
    <ts-button :loading="loading" title="Share" size="small" type="primary" filled @click="handleOpenDialogButtonClick">
      Share your working files
    </ts-button>
  </div>
</template>

<script>
import { config, appId } from '@/api/workflow';
import { required } from 'vuelidate/lib/validators';
import { mapState, mapActions } from 'vuex';
import projectViewHelpers from '@/mixins/projectViewHelpers';

export default {
  mixins: [projectViewHelpers],
  props: {
    assets: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      showChecklist: false,
      appUrl: null,
      form: {
        email: '',
        message: ''
      }
    };
  },
  computed: {
    ...mapState('workflow', {
      project: state => state.currentProject.value
    }),
    sharing() {
      return this.project.sharings.find(s => s.resource === 'working_files');
    },
    url() {
      return `${this.appUrl}/projects/sharings/${this.sharing?.token}`;
    }
  },
  validations: {
    form: {
      email: {
        required
      },
      message: {}
    }
  },
  methods: {
    ...mapActions('workflow', ['shareProjectResource']),
    async copy() {
      try {
        await this.$copyText(this.url);
        this.showInfo('Link copied to clipboard');
      } catch (err) {
        console.error('Error when copying file request link', err);
        this.showError('Error when copying step link');
      }
    },
    handleCloseButton() {
      this.visible = false;
    },
    handleOpenDialogButtonClick() {
      this.handleSharing();
    },
    handleSharing() {
      this.loading = true;
      this.grabSharingLink().then(() => {
        this.loading = false;
        this.visible = true;
      });
    },
    async grabSharingLink() {
      return await this.shareWorkingFiles();
    },
    async shareWorkingFiles() {
      return await this.shareProjectResource({
        projectId: this.project.id,
        resource: 'working_files',
        extras: {
          assets: this.assets.map(asset => asset.id)
        }
      });
    },
    resetForm() {
      this.form = {
        email: '',
        message: ''
      };

      this.$v.$reset();
    },
    skip() {
      this.visible = false;
      this.resetForm();
    },
    handleSaveClick() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit('input', this.form);
        this.visible = false;
        this.resetForm();
      }
    }
  },
  async mounted() {
    this.appUrl = config('auth.appUrl');
    window.EventBus.$on('Delivery.ShareFinalAssets', () => {
      this.handleOpenDialogButtonClick();
    });
  }
};
</script>

<style lang="scss" scoped>
.hide {
  display: none;
}
.checklist {
  table {
    width: 100%;
    tr {
      padding: 10px;
      &:nth-child(2n) {
        td {
          // border-top: 1px solid rgba(0, 0, 0, 0.1);
        }
      }
      td {
        .cell-container.right {
          text-align: center;
        }
        .cell-container.left {
          font-size: 1rem;
          color: #6d7587;
          word-break: break-word;
          white-space: normal;
          text-align: left;
        }
        .cell-container {
          padding: 16px;
        }
      }
    }
  }
}
.row {
  background: #ebecf0;
  background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  border: 2px solid rgba(255, 255, 255, 0.16);
  box-shadow: -2px -2px 6px 0 rgba(250, 251, 255, 0.48), 2px 2px 6px 0 rgba(166, 171, 189, 0.24);
  border-radius: 16px;
  margin-bottom: 10px;

  display: flex;
  align-items: center;
  padding: 22px 18px;

  .checkbox {
    margin-right: 13px;
  }

  .file-info {
    width: 400px;
  }

  .file-name {
    font-family: Roboto;
    font-size: 16px;
    color: #6d7587;
  }

  .file-creation-info {
    font-family: Roboto;
    font-size: 10px;
    line-height: 16px;
    color: #acbacc;
  }

  .files {
    flex-grow: 1;
  }

  .actions {
    display: flex;
    align-items: center;

    > * {
      margin-left: 10px;
    }
  }
}
.flex {
  display: flex;
}
.justify-center {
  justify-content: center;
}
.items-center {
  align-items: center;
}
.mb-2 {
  margin-bottom: 0.5em;
}
.flex-1 {
  flex: auto;
}
.flex-none {
  flex: none;
}
.px-2 {
  padding-left: 0.5em;
  padding-right: 0.5em;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.py-2 {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}
.justify-between {
  justify-content: space-between;
}
.cursor-pointer {
  cursor: pointer;
}
</style>